import { render, staticRenderFns } from "./AppealsModal.vue?vue&type=template&id=117b6416&scoped=true&"
import script from "./AppealsModal.vue?vue&type=script&lang=js&"
export * from "./AppealsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117b6416",
  null
  
)

export default component.exports